import moment from 'moment';
import { dropLogistica, dropStatusDocumento } from 'utils/drops';

const getPedidosFilterFields = (drops = {}) => [
  {
    name: 'id',
    label: 'ID',
    type: 'number',
  },
  {
    name: 'status',
    label: 'Status',
    type: 'select',
    options: dropStatusDocumento,
    multiple: true,
    defaultValue: ['PENDENTE'],
  },
  {
    name: 'situacao',
    label: 'Situação',
    type: 'select',
    options: drops?.StatusDocumento,
    multiple: true,
  },
  {
    name: 'marketplace_name',
    label: 'Marketplace',
  },
  {
    name: 'marketplace_package_id',
    label: 'Marketplace Pacote',
  },
  {
    name: 'marketplace_logistica',
    label: 'Marketplace Logística',
    type: 'select',
    options: dropLogistica,
  },
  {
    name: 'dtemissao.i',
    column: 'dtemissao',
    label: 'Data de Emissão Inicial',
    type: 'date',
    defaultValue: moment().subtract(1, 'months').format('YYYY-MM-DD'),
  },
  {
    name: 'dtemissao.f',
    column: 'dtemissao',
    label: 'Data de Emissão Final',
    type: 'date',
  },
  {
    name: 'documento',
    label: 'Nº do Documento',
    type: 'number',
    initial: true,
  },
  {
    name: 'entidade',
    label: 'Entidade',
    type: 'virtual-select',
    options: drops?.Entidade,
    multiple: true,
  },
  {
    name: 'filial',
    label: 'Filial',
    type: 'virtual-select',
    options: drops?.EntidadeTipo?.filter((f) => f?.tipo === 'FILIAL'),
    multiple: true,
  },
  {
    name: 'vldocto',
    label: 'Valor',
    type: 'currency',
  },
  {
    name: 'przent.i',
    column: 'przent',
    label: 'Prazo de Entrega Inicial',
    type: 'date',
  },
  {
    name: 'przent.f',
    column: 'przent',
    label: 'Prazo de Entrega Final',
    type: 'date',
  },
  {
    name: 'destino',
    label: 'Destino',
  },
  {
    name: 'documento_nota',
    label: 'Nº da Nota',
    type: 'number',
  },
  {
    name: 'vendedor',
    label: 'Vendedor',
    type: 'virtual-select',
    options: drops?.EntidadeTipo?.filter(
      (f) => f?.tipo === 'VENDEDOR' || f?.tipo === 'REPRESENTANTE'
    ),
    multiple: true,
  },
  {
    name: 'forma_pagto',
    label: 'Forma de Pagamento',
  },
  {
    name: 'whatsapp',
    label: 'Contato',
  },
  {
    name: 'ped_cliente',
    label: 'Nº do Pedido do Cliente',
  },
];

export default getPedidosFilterFields;
